// One stroke icon set (24-unit grid, 1.6 stroke), shared with Android via packages/tokens/icons.json.
import { ICONS, FILLED } from "./icons.gen";

export function Icon({ name, size = 18, className = "" }: { name: string; size?: number; className?: string }) {
  return (
    <svg className={`i ${className}`} width={size} height={size} viewBox="0 0 24 24" aria-hidden="true"
      fill={FILLED.has(name) ? "currentColor" : "none"} stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round">
      <path d={ICONS[name] ?? ICONS.circle} />
    </svg>
  );
}
